import { defineComponent as d, ref as c, onMounted as p, onUpdated as v, provide as h, openBlock as g, createElementBlock as b, normalizeClass as _, createVNode as n, unref as l, withCtx as i, renderSlot as k } from "vue";
import { theme as C, themeOverrides as S } from "./ghl-ui.es282.js";
import "./ghl-ui.es283.js";
import "./ghl-ui.es284.js";
import { GHLLanguageKeys as a } from "./ghl-ui.es285.js";
import { date_en_US as u } from "./ghl-ui.es286.js";
import y from "./ghl-ui.es287.js";
import L from "./ghl-ui.es288.js";
import { NModalProvider as U } from "./ghl-ui.es289.js";
import { hu as w } from "./ghl-ui.es290.js";
import { date_hu as B } from "./ghl-ui.es291.js";
import { hr as P } from "./ghl-ui.es292.js";
import { date_hr as x } from "./ghl-ui.es293.js";
import { sv as N } from "./ghl-ui.es294.js";
import { date_sv as R } from "./ghl-ui.es295.js";
import { es as A } from "./ghl-ui.es296.js";
import { date_es as F } from "./ghl-ui.es297.js";
import { ptBR as z } from "./ghl-ui.es298.js";
import { date_pt_BR as I } from "./ghl-ui.es299.js";
import { ptPT as M } from "./ghl-ui.es300.js";
import { date_pt_PT as O } from "./ghl-ui.es301.js";
import { no as T } from "./ghl-ui.es302.js";
import { date_no as W } from "./ghl-ui.es303.js";
import { it as $ } from "./ghl-ui.es304.js";
import { date_it as j } from "./ghl-ui.es305.js";
import { de as D } from "./ghl-ui.es306.js";
import { date_de as E } from "./ghl-ui.es307.js";
import { frFR as G } from "./ghl-ui.es308.js";
import { date_fr_FR as H } from "./ghl-ui.es309.js";
import { frCA as K } from "./ghl-ui.es310.js";
import { date_fr_CA as V } from "./ghl-ui.es311.js";
import { fi as q } from "./ghl-ui.es312.js";
import { date_fi as J } from "./ghl-ui.es313.js";
import { nl as Q } from "./ghl-ui.es314.js";
import { date_nl as X } from "./ghl-ui.es315.js";
import { da as Y } from "./ghl-ui.es316.js";
import { date_da as Z } from "./ghl-ui.es317.js";
import { enUS as s } from "./ghl-ui.es318.js";
const ee = d({
  name: "UIContentWrap",
  inheritAttrs: !0
}), ae = d({
  ...ee,
  props: {
    fullScreen: {
      type: Boolean,
      default: !1
    },
    locale: {
      type: String,
      default: a.englishUS
    },
    notificationConfig: {
      type: Object,
      default: () => ({})
    }
  },
  setup(t) {
    const r = t, e = c(s), o = c(u), m = () => {
      switch (function() {
        return r != null && r.locale ? r.locale.includes("_") ? (console.warn(
          `Deprecated used of '_' in the language '${r.locale}', please change to use hyphen '-'.`
        ), r.locale.replace("_", "-")) : r.locale : a.englishUS;
      }()) {
        case a.englishUS:
        default: {
          e.value = s, o.value = u;
          break;
        }
        case a.danish: {
          e.value = Y, o.value = Z;
          break;
        }
        case a.dutch: {
          e.value = Q, o.value = X;
          break;
        }
        case a.finnish: {
          e.value = q, o.value = J;
          break;
        }
        case a.frenchCanada: {
          e.value = K, o.value = V;
          break;
        }
        case a.frenchFrance: {
          e.value = G, o.value = H;
          break;
        }
        case a.german: {
          e.value = D, o.value = E;
          break;
        }
        case a.italian: {
          e.value = $, o.value = j;
          break;
        }
        case a.norwegian: {
          e.value = T, o.value = W;
          break;
        }
        case a.portuguesePortugal: {
          e.value = M, o.value = O;
          break;
        }
        case a.portugueseBrazil: {
          e.value = z, o.value = I;
          break;
        }
        case a.spanish: {
          e.value = A, o.value = F;
          break;
        }
        case a.swedish: {
          e.value = N, o.value = R;
          break;
        }
        case a.croatian: {
          e.value = P, o.value = x;
          break;
        }
        case a.hungarian: {
          e.value = w, o.value = B;
          break;
        }
      }
    };
    return p(() => {
      m();
    }), v(() => {
      m();
    }), h("customLocale", e), (f, oe) => (g(), b("div", {
      class: _(["font-sans hl-wrapper-container", { "full-screen": t.fullScreen }])
    }, [
      n(l(y), {
        theme: l(C),
        "theme-overrides": l(S),
        locale: e.value,
        "date-locale": o.value
      }, {
        default: i(() => [
          n(l(L), {
            "container-class": t.notificationConfig.containerClass,
            "container-style": t.notificationConfig.containerStyle,
            to: t.notificationConfig.to,
            placement: t.notificationConfig.placement,
            max: t.notificationConfig.max,
            scrollable: t.notificationConfig.scrollable
          }, {
            default: i(() => [
              n(l(U), null, {
                default: i(() => [
                  k(f.$slots, "default")
                ]),
                _: 3
              })
            ]),
            _: 3
          }, 8, ["container-class", "container-style", "to", "placement", "max", "scrollable"])
        ]),
        _: 3
      }, 8, ["theme", "theme-overrides", "locale", "date-locale"])
    ], 2));
  }
}), je = ae;
export {
  je as default
};
